export default "__VITE_ASSET__DsNlIsPe__"